function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 215.115c42.873 0 42.873-65.03 85.746-65.03 42.875 0 42.875 65.03 85.749 65.03 42.876 0 42.876-65.03 85.752-65.03s42.876 65.03 85.753 65.03"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 202.729c42.873 0 42.873-65.03 85.746-65.03 42.875 0 42.875 65.03 85.749 65.03 42.876 0 42.876-65.03 85.752-65.03s42.876 65.03 85.753 65.03"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 190.342c42.873 0 42.873-65.03 85.746-65.03 42.875 0 42.875 65.03 85.749 65.03 42.876 0 42.876-65.03 85.752-65.03s42.876 65.03 85.753 65.03"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 177.955c42.873 0 42.873-65.03 85.746-65.03 42.875 0 42.875 65.03 85.749 65.03 42.876 0 42.876-65.03 85.752-65.03s42.876 65.03 85.753 65.03"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 165.569c42.873 0 42.873-65.03 85.746-65.03 42.875 0 42.875 65.03 85.749 65.03 42.876 0 42.876-65.03 85.752-65.03s42.876 65.03 85.753 65.03"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 153.182c42.873 0 42.873-65.03 85.746-65.03 42.875 0 42.875 65.03 85.749 65.03 42.876 0 42.876-65.03 85.752-65.03s42.876 65.03 85.753 65.03"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 140.796c42.873 0 42.873-65.03 85.746-65.03 42.875 0 42.875 65.03 85.749 65.03 42.876 0 42.876-65.03 85.752-65.03s42.876 65.03 85.753 65.03"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 128.41c42.873 0 42.873-65.03 85.746-65.03 42.875 0 42.875 65.03 85.749 65.03 42.876 0 42.876-65.03 85.752-65.03s42.876 65.03 85.753 65.03"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 116.023c42.873 0 42.873-65.03 85.746-65.03 42.875 0 42.875 65.03 85.749 65.03 42.876 0 42.876-65.03 85.752-65.03s42.876 65.03 85.753 65.03"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 103.636c42.873 0 42.873-65.03 85.746-65.03 42.875 0 42.875 65.03 85.749 65.03 42.876 0 42.876-65.03 85.752-65.03s42.876 65.03 85.753 65.03"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 91.25c42.873 0 42.873-65.03 85.746-65.03 42.875 0 42.875 65.03 85.749 65.03 42.876 0 42.876-65.03 85.752-65.03S300.123 91.25 343 91.25"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 78.863c42.873 0 42.873-65.03 85.746-65.03 42.875 0 42.875 65.03 85.749 65.03 42.876 0 42.876-65.03 85.752-65.03s42.876 65.03 85.753 65.03"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 66.476c42.873 0 42.873-65.03 85.746-65.03 42.875 0 42.875 65.03 85.749 65.03 42.876 0 42.876-65.03 85.752-65.03s42.876 65.03 85.753 65.03"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 343 216"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
};

export default __webpack_public_path__ + "static/media/parallel-lines-mobile.53adbc7b.svg";
export { SvgComponent as ReactComponent };